import Box from '@mui/material/Box';
import { Filter, FilterType } from '../../../../features/filters/FilterTypes';
import { useState } from 'react';
import ReportFilters from '../ReportSelector/ReportFilters';
import ReportDisplay from '../ReportDisplay/ReportDisplay';
import useReportSelector from '../ReportSelector/ReportSelector.hooks';
import StandardButton from '../../../components/Button/StandardButton';
import AssessmentIcon from '@mui/icons-material/Assessment';
import SectionAppBar from '../../../components/Section/SectionAppBar';

const ReportPage = () => {
    const [filter, setFilter] = useState({
        id: crypto.randomUUID(),
        description: '',
        searchTerm: '',
        options: [],
        activityDate: 'any',
        filterType: FilterType.User,
    } as Filter);
    const [filtersOpen, setFiltersOpen] = useState(false);

    const { reports, selectedReport, reportResult, handleReportChange, handleGenerateReport } = useReportSelector();

    const onShowFilters = () => {
        setFiltersOpen(true);
    };

    const onCloseFilter = () => {
        setFiltersOpen(false);
    };

    const onFiltersChanged = (newFilter: Filter) => {
        setFilter(newFilter);
    };

    return (
        <Box>
            <SectionAppBar
                title="Reporting"
                subTitle=""
                buttons={
                    <>
                        <ReportFilters
                            onChange={onFiltersChanged}
                            selectedReport={selectedReport}
                            handleReportChange={handleReportChange}
                            reports={reports}
                        />

                        <StandardButton
                            icon={<AssessmentIcon />}
                            onClick={() => handleGenerateReport(filter)}
                            sx={{ alignSelf: 'center' }}
                        >
                            Generate
                        </StandardButton>
                    </>
                }
            />

            <Box mt={4}>
                <ReportDisplay reportResult={reportResult} />
            </Box>
        </Box>
    );
};

ReportPage.guestGuard = false;
ReportPage.authGuard = true;

export { ReportPage };
export default ReportPage;
